import React from 'react'
import SignUpForm from '../Components/Login_Components/Signup/SignUpForm'
import LoginNavbar from '../Layouts/LoginNavbar'

const Register = () => {
  return (
    <div>
      <LoginNavbar/>
      <SignUpForm/>
    </div>
  )
}

export default Register